export const LogoMark = ({ className = "h-8 w-8" }) => (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
        <rect width="64" height="64" fill="#121212" />
        <path
            d="M18 46V30a14 14 0 0 1 28 0v16"
            fill="none"
            stroke="#FFFFFF"
            strokeWidth="3.5"
            strokeLinecap="square"
        />
        <circle cx="32" cy="24" r="4.5" fill="#9E7B56" />
    </svg>
);
